import { __assign } from "tslib";
import { DEFAULT_CALENDAR_STRINGS } from '@fluentui/date-time-utilities';
export var defaultWeeklyDayPickerStrings = __assign(__assign({}, DEFAULT_CALENDAR_STRINGS), { prevWeekAriaLabel: 'Previous week', nextWeekAriaLabel: 'Next week', prevMonthAriaLabel: 'Go to previous month', nextMonthAriaLabel: 'Go to next month', prevYearAriaLabel: 'Go to previous year', nextYearAriaLabel: 'Go to next year', closeButtonAriaLabel: 'Close date picker' });
export var defaultWeeklyDayPickerNavigationIcons = {
    leftNavigation: 'ChevronLeft',
    rightNavigation: 'ChevronRight',
};
//# sourceMappingURL=defaults.js.map